import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#003E7E', // Navy Blue (brand color)
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#FF6600', // Orange (brand accent)
      contrastText: '#ffffff',
    },
    success: {
      main: '#4caf50', // Green
    },
    error: {
      main: '#f44336', // Red
    },
    warning: {
      main: '#ffc107', // Amber
    },
    info: {
      main: '#17a2b8', // Cyan
    },
    background: {
      default: '#f8f9fa', // Light gray background
      paper: '#ffffff',
    },
    text: {
      primary: '#212529', // Dark gray (almost black)
      secondary: '#6c757d', // Medium gray
    },
    // Custom committee colors for future use
    committee: {
      physical: '#993399', // Purple
      electrical: '#f44336', // Red
      civil: '#795548', // Brown
      business: '#000099', // Dark blue
      technology: '#339966', // Green
      general: '#4caf50', // Light green
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 600,
    },
    h3: {
      fontWeight: 600,
    },
    h4: {
      fontWeight: 500,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
    button: {
      textTransform: 'none', // Don't uppercase button text
      fontWeight: 500,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 576, // Match Bootstrap 5
      md: 768, // Match Bootstrap 5
      lg: 992, // Match Bootstrap 5
      xl: 1200, // Match Bootstrap 5
      xxl: 1400, // Match Bootstrap 5 (custom breakpoint)
    },
  },
  spacing: 8, // 8px base unit (matches Bootstrap's rem-based spacing)
  shape: {
    borderRadius: 5, // Default border radius for components
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 5,
          textTransform: 'none',
          fontWeight: 500,
          padding: '10px 20px',
        },
        containedPrimary: {
          '&:hover': {
            backgroundColor: '#002d5c', // Darker navy on hover
          },
        },
        containedSecondary: {
          '&:hover': {
            backgroundColor: '#ff5200', // Darker orange on hover
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 10,
        },
        rounded: {
          borderRadius: 10,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: '#343a40', // Dark background (matching Bootstrap navbar-dark)
        },
        colorPrimary: {
          backgroundColor: '#343a40',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          textDecoration: 'none',
          '&:hover': {
            textDecoration: 'underline',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 5,
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: {
          borderRadius: 5,
        },
      },
    },
  },
});

export default theme;
